import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../redux/features/auth/authSlice';
import colorReducer from '../redux/features/colors/colorsSlice';
import transmissionReducer from '../redux/features/transmissions/transmissionsSlice';
import featureReducer from '../redux/features/features/featuresSlice';
import fuelReducer from '../redux/features/fuels/fuelsSlice';
import countryReducer from '../redux/features/countries/countriesSlice';
import vehicleTypeReducer from '../redux/features/vehicleTypes/vehicleTypesSlice';
import makeReducer from '../redux/features/makes/makesSlice';
import modelReducer from '../redux/features/models/modelsSlice';
import modelCodeReducer from '../redux/features/modelCodes/modelCodesSlice';
import vehicleReducer from '../redux/features/vehicle/vehicleSlice';
import vehicleCostReducer from '../redux/features/vehicleCost/vehicleCostSlice';
import ordersReducer from '../redux/features/orders/ordersSlice';
import customersReducer from '../redux/features/customers/customersSlice';
import staffReducer from '../redux/features/staff/staffSlice';
import customerrequestReducer from '../redux/features/customerRequests/customerRequestsSlice';
import invoiceReducer from '../redux/features/invoice/invoiceSlice';
import paymentReducer from '../redux/features/payments/paymentSlice';
import documentReducer from '../redux/features/document/documentSlice';
import ledgerReducer from '../redux/features/ledgers/ledgersSlice';
import bannerReducer from '../redux/features/banner/bannerSlice';
import inquiryReducer from '../redux/features/inquiries/inquiriesSlice';
import currencyReducer from '../redux/features/currency/currencySlice';
import dashboardReducer from '../redux/features/dashboard/dashboardSlice';
import vehicleInvoiceReducer from '../redux/features/vehicleInvoice/vehicleInvoiceSlice';
import bankReducer from '../redux/features/bank/bankSlice';
import quickInvoicReducer from '../redux/features/quickInvoice/quickInvoiceSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    color: colorReducer,
    transmission: transmissionReducer,
    feature: featureReducer,
    fuel: fuelReducer,
    country: countryReducer,
    vehicleType: vehicleTypeReducer,
    make: makeReducer,
    model: modelReducer,
    modelCode: modelCodeReducer,
    vehicle: vehicleReducer,
    vehicleCost: vehicleCostReducer,
    order: ordersReducer,
    customer: customersReducer,
    staff: staffReducer,
    customerRequest: customerrequestReducer,
    invoice: invoiceReducer,
    payment: paymentReducer,
    document: documentReducer,
    ledger: ledgerReducer,
    banner: bannerReducer,
    inquiry: inquiryReducer,
    currency: currencyReducer,
    dashboard: dashboardReducer,
    vehicleInvoice: vehicleInvoiceReducer,
    bank: bankReducer,
    quickInvoice: quickInvoicReducer,
  },
});

export default store;
